// global emitter
import mitt from "mitt";
import { SweetAlertOptions } from "sweetalert2";

type Events = {
  // key : event value
  globalPopup: string | SweetAlertOptions;
  globalLoading: boolean | string;
  showLeftMenu: boolean;
};

export const emitter = mitt<Events>();

type RsEvent = {
  getDas: any; // web socket
  setBin: any; // to communicate between parent and child
  arrived: any; // web socket
  boxArrived: any; // web socket
};

export const rsEmitter = mitt<RsEvent>();
